// configs for UI components

export const uiConfig = {
  avatarBackgroundColors: ['primary.main'],
};

export default uiConfig;
